import { render, staticRenderFns } from "./tigerzzVideo.vue?vue&type=template&id=1e2bf14a&scoped=true&"
import script from "./tigerzzVideo.vue?vue&type=script&lang=js&"
export * from "./tigerzzVideo.vue?vue&type=script&lang=js&"
import style0 from "./tigerzzVideo.vue?vue&type=style&index=0&id=1e2bf14a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2bf14a",
  null
  
)

export default component.exports